module.exports = __webpack_public_path__ + "static/media/thanks.75f6eaf3.png";